module.exports = __webpack_public_path__ + "static/nfui-5014284fecf0556c25f027a20c81b762.gif";